import Icon from '../components/Icon.vue'

Icon.register({
  'user-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 288c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM384 320c70.7 0 128 57.3 128 128v16c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-16c0-70.7 57.3-128 128-128h55.1c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h55.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/user-alt.js
// module id = 1850
// module chunks = 0